import {forestCoverLossRenderer} from "@/views/mills/data/forestCoverLossRenderer";
import {arcgisURL} from "@/config/api-config";

const forestCoverLossLayer = {
    title: "Forest Cover Loss",
    url: arcgisURL + "forestCover/FeatureServer",
    opacity: 0.8,
    copyright: "",
    geometryType: "polygon",
    renderer: forestCoverLossRenderer,
    popupTemplate: {
        title: "{ADM1_EN} State",
        content: [
            {
                type: "fields",
                fieldInfos: [
                    {
                        fieldName: "ADM1_EN",
                        label: "State",
                        visible: true,
                    },
                    {
                        fieldName: "loss",
                        label: "Forest Cover Loss (ha)",
                        visible: true,
                        format: {
                            places: 2,
                            digitSeparator: true,
                        },
                    },
                ],
            },
        ],
    },
}
export default forestCoverLossLayer;

